import { useEffect } from "react";

export const QRCode = () => {
  useEffect(() => {
    window.location.href = "https://heylink.me/ArayehCo/";
  }, []);
  return (
    <div className="flex-center" style={{ width: "100vw", height: "90vh" }}>
      <img src="/assets/logo.png" width={"20%"} alt="ArayehCo." />
    </div>
  );
};
